const comments = [
  {
    avatar: '瓜',
    name: '吃瓜小能手',
    date: '2小时前',
    content: '每天都在今日大瓜蹲最新的娱乐热点，更新速度真的快！昨天那个爆料我在这边第一时间就看到了，同事还在刷别的平台，我已经吃完全瓜了。',
    tag: '忠实用户',
  },
  {
    avatar: '爆',
    name: '娱乐圈观察员',
    date: '5小时前',
    content: '内容质量很不错，不像有些平台全是标题党。这边的热点大瓜追踪做得很到位，时间线清晰，来龙去脉梳理得明明白白，吃瓜体验满分。',
    tag: '活跃用户',
  },
  {
    avatar: '料',
    name: '热心爆料人',
    date: '1天前',
    content: '作为一个老吃瓜人，今日大瓜是我见过最全的热点吃瓜平台。分类清晰，搜索方便，热门事件一网打尽。已经推荐给身边所有爱八卦的朋友了。',
    tag: '资深用户',
  },
];

export default function CommentsSection() {
  return (
    <section
      id="comments"
      className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50"
      style={{ scrollMarginTop: '80px' }}
    >
      <div className="w-full max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            瓜友热评
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">
            听听吃瓜群众怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {comments.map((item, i) => (
            <div
              key={i}
              className="flex flex-col p-5 md:p-6 rounded-lg bg-background-100 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 font-bold text-sm">
                  {item.avatar}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="font-medium text-sm text-foreground-900 whitespace-nowrap">
                      {item.name}
                    </span>
                    <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-500">{item.date}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                &ldquo;{item.content}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}